import React from 'react';
import { Edit } from 'react-admin';
import { EquipmentForm } from '../../components/shared/EquipmentForm';
import ResourceBreadcrumbs from '../../components/ResourceBreadcrumbs';

export const EquipmentEdit = () => (
  <>
    <ResourceBreadcrumbs />
    <Edit title="Edit Company Vehicle" actions={false}>
      <EquipmentForm />
    </Edit>
  </>
);